import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OtpService {

  env = environment;
  constructor(private readonly http: HttpClient) { }

  sendOtp(data: any) {
    return this.http.post(this.env.webApiUrl + 'api/Otp/SendOtp', data);
  }

  validateOtp(data: any) {
    return this.http.post(this.env.webApiUrl + 'api/Otp/ValidateOtp', data);
  }

  mfaSessionExpired() {
    return this.http.post(this.env.webApiUrl + 'api/Otp/MfaSessionExpired', {});
  }

  forgotPasswordSendOtp(data: any) {
    const reqHeader = new HttpHeaders({ 'Content-Type': 'application/json', 'No-Auth': 'True' });
    return this.http.post(this.env.webApiUrl + 'api/User/ForgotPasswordSendOtp', data, { headers: reqHeader });
  }

  forgotPasswordUpdate(data: any) {
    return this.http.post(this.env.webApiUrl + 'api/User/ForgotPassword', data);
  }

}
